module.exports = __webpack_public_path__ + "static/media/yo2.d8a405f0.jpg";